import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import Api from "../service/http";
import Sidebar from "./Sidebar";
import DashboardNavbar from "./DashboardNavbar";

const Leftbar = () => {
  const navigate = useNavigate();
  const { theme } = useSelector((state) => state.theme);
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('user')) || null);
  const [active, setActive] = useState();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const isLoggedIn = localStorage.getItem("accessToken") ? true : false;

  const menu = [
    { id: 1, name: "Dashboard", slug: "dashboard", type: 1 },
    { id: 2, name: "Personal Chat", slug: "personal-chat", type: 1 },
    { id: 3, name: "Group Chat", slug: "chat", type: 1 },
    { id: 4, name: "Market Data", slug: "market-data", type: 1 },
    { id: 5, name: "Courses", slug: "courses", type: 1 },
    { id: 6, name: "Alerts", slug: "site-alerts", type: 1 },
    { id: 7, name: "Profile", slug: "profile", type: 1 },
  ];

  useEffect(() => {
    const currentPath = window.location.pathname.split("/")[1];
    const currentMenu = menu.find(item => item.slug === currentPath);
    if (currentMenu && currentMenu?.type === 2 && (!user?.expired_at || new Date(user?.expired_at) < new Date())) {
      navigate("/dashboard");
    }
    setActive(currentMenu?.id);
  }, [window.location.pathname, user]);

  const getProfile = async () => {
    try {
      const res = await Api.get("/web/profile");
      if (res?.data?.user) {
        localStorage.setItem("user", JSON.stringify(res?.data?.user));
        setUser(res?.data?.user);
      }
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  };

  useEffect(() => {
    if (isLoggedIn) {
      getProfile();
    }
  }, [isLoggedIn]);

  if (!isLoggedIn) {
    return <Navigate to="/signin" replace />;
  }

  return (
    <div className={`flex h-screen overflow-hidden ${theme === 'dark' ? 'bg-[#2f3349]' : 'bg-gray-50'}`}>
      {/* Sidebar Component */}
      <Sidebar 
        active={active} 
        setActive={setActive} 
        user={user} 
        isOpen={sidebarOpen} 
        setIsOpen={setSidebarOpen} 
        isCollapsed={sidebarCollapsed}
        setIsCollapsed={setSidebarCollapsed}
      />

      <div className="flex flex-col flex-1 min-w-0 h-full overflow-hidden transition-all duration-300 relative">
        {/* Navbar Component */}
        <DashboardNavbar 
          user={user} 
          toggleSidebar={() => setSidebarOpen(!sidebarOpen)} 
        />

        {/* Main Content */}
        <main className="flex-1 overflow-hidden px-4 sm:px-6 pb-4 sm:pb-6 scroll-smooth flex flex-col min-h-0">
          <div className={`flex-1 transition-colors duration-300 overflow-hidden rounded-xl shadow-md ${
            theme === 'dark' ? 'bg-[#232634] text-[#cfd3ec]' : 'bg-white text-gray-800'
          }`}>
            <div className="h-full flex flex-col overflow-y-auto">
              <Outlet context={{ user }} />
            </div>
          </div>
        </main>

        <footer className={`px-4 sm:px-6 py-4 border-t flex-shrink-0 ${
          theme === 'dark' ? 'border-gray-700/50 text-gray-400' : 'border-gray-100 text-gray-500'
        }`}>
          <div className="flex flex-col sm:flex-row justify-between items-center text-[10px] sm:text-xs">
            <span className="text-center sm:text-left">
              &copy; {new Date().getFullYear()} Developed and Maintained by{" "}
              <span className="font-semibold text-indigo-500 text-nowrap">It's all About the Options</span>
            </span>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default Leftbar;
